var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHero = function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    viewBox: "0 0 960 540"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#009AD7",
    d: "M0 0h960v540H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#42a5f5",
    d: "m0 266 40-6.2c40-6.1 120-18.5 200 1.9 80 20.3 160 73.3 240 78.5 80 5.1 160-37.5 240-41.9C800 294 880 328 920 345l40 17v179H0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0d1fb",
    d: "m0 326 40 13.2c40 13.1 120 39.5 200 38.5s160-29.4 240-33.2 160 16.8 240 24 160 .8 200-2.3l40-3.2v178H0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m0 402 40-1.5c40-1.5 120-4.5 200 8.5s160 42 240 43 160-26 240-39.7c80-13.6 160-14 200-14.1l40-.2v143H0Z"
  })));
};
export default SvgHero;